import React from "react";
import { useState, useEffect } from "react";
import "./App.css";
import mondaySdk from "monday-sdk-js";
import "monday-ui-react-core/dist/main.css";
import "typeface-roboto";
import "typeface-poppins";
import "@fontsource/figtree";
import MainGrid from "./components/main-grid/main-grid";
import { ThemeProvider, Text } from "monday-ui-react-core";

// Usage of mondaySDK example, for more information visit here: https://developer.monday.com/apps/docs/introduction-to-the-sdk/
const monday = mondaySdk();

const App = () => {
  const [context, setContext] = useState();

  useEffect(() => {
    // Notice this method notifies the monday platform that user gains a first value in an app.
    // Read more about it here: https://developer.monday.com/apps/docs/mondayexecute#value-created-for-user/
    monday.execute("valueCreatedForUser");

    // TODO: set up event listeners, Here`s an example, read more here: https://developer.monday.com/apps/docs/mondaylisten/
    monday.listen("context", (res) => {
      setContext(res.data);
    });
  }, []);

  return (
      <div className="App">
        <ThemeProvider systemTheme={context ? context.theme : ThemeProvider.systemThemes.LIGHT}>
          <MainGrid />
        </ThemeProvider> 
      </div>
  );

};

export default App;
